import { DateTime } from 'luxon';
import { dineroGetPercentage, dineroMultiply, fromISOtoFormat } from './dataFormat';

interface IDuration {
  start: string;
  end: string;
}

const handleFormat = (date: string) => {
  return fromISOtoFormat(date, 'yyyy/LL/dd');
};

const checkIntersection = (intA: IDuration, intB: IDuration) => {
  return (
    handleFormat(intA.start) <= handleFormat(intB.end) &&
    handleFormat(intB.start) <= handleFormat(intA.end)
  );
};

const findIntersectionInterval = (intA: IDuration, intB: IDuration) => {
  if (checkIntersection(intA, intB)) {
    const intersectionStart =
      handleFormat(intA.start) > handleFormat(intB.start) ? intA.start : intB.start;
    const intersectionEnd = handleFormat(intA.end) < handleFormat(intB.end) ? intA.end : intB.end;
    const duration = DateTime.fromISO(intersectionEnd).diff(
      DateTime.fromISO(intersectionStart),
      'days'
    );
    return Math.ceil(Math.abs(duration.days));
  }
  return null;
};

const getDuration = (season: IDuration, order: IDuration) => {
  const start =
    handleFormat(order.start) >= handleFormat(season.start) ? order.start : season.start;
  const end = handleFormat(order.end) >= handleFormat(season.end) ? season.end : order.end;
  const duration = DateTime.fromISO(end).diff(DateTime.fromISO(start), 'days').days;
  return Math.ceil(Math.abs(duration));
};

const getExtraPrice = (vanPricePerDay: number, duration: number, rate: number) => {
  const vanPrice = dineroMultiply(vanPricePerDay, Math.ceil(duration));
  return dineroMultiply(dineroGetPercentage(vanPrice, Math.abs(rate)), Math.sign(rate));
};

function getDaysInRange(start: string, end: string) {
  let startDate = DateTime.fromISO(start);
  const endDate = DateTime.fromISO(end);
  const dates = [];
  while (startDate <= endDate) {
    dates.push(startDate.toISODate());
    startDate = startDate.plus({ days: 1 });
  }
  return dates;
}

const DatesObj = (start: string, end: string, rate: number): { [key: string]: number } => {
  const dates = getDaysInRange(start, end);
  const obj = dates.reduce((obj, item: string) => {
    (obj as { [key: string]: number })[item] = rate;
    return obj;
  }, {});
  return obj;
};

export { findIntersectionInterval, handleFormat, getDuration, getExtraPrice, DatesObj };
